import type { ReactNode, FC } from 'react';
import ReactDocumentTitle from 'react-document-title';

interface Props {
  title: string;
  children: ReactNode;
}

const DocumentTitle: FC<Props> = (props) => {
  return (
    // TODO: Remove and replace with a normal title tag when upgrading to React 19.
    <ReactDocumentTitle title={`${props.title} | Kilotype`}>
      <>{props.children}</>
    </ReactDocumentTitle>
  );
};

DocumentTitle.displayName = 'Core.DocumentTitle';

export default DocumentTitle;
